import { useAvaNotifications } from '../../../hooks/useAvaNotifications';
import '../../../styles/AvaToasts.css';
import avaAvatar from './ava-avatar.png';

// Floating stack of Ava (آوا) proactive notifications (reminders etc.). Mounted
// once in the admin shell, OUTSIDE the tab content, so a reminder surfaces no
// matter which admin tab is open. Renders nothing until a notification arrives.
export default function AvaNotificationToasts() {
  const { toasts, dismiss } = useAvaNotifications();
  if (!toasts.length) return null;
  return (
    <div className="ava-toasts" dir="rtl" aria-live="polite">
      {toasts.map((t) => (
        <div key={t.id} className="ava-toast" role="status">
          <img className="ava-toast-avatar" src={avaAvatar} alt="آوا" />
          <div className="ava-toast-text">
            {t.title && <div className="ava-toast-title">{t.title}</div>}
            {t.body && <div className="ava-toast-body">{t.body}</div>}
          </div>
          <button
            type="button"
            className="ava-toast-close"
            onClick={() => dismiss(t.id)}
            aria-label="بستن"
          >
            ×
          </button>
        </div>
      ))}
    </div>
  );
}
